export default __webpack_public_path__ + "static/media/kimbu5.e85cf5a5.jpg";